import React from 'react'
import { Row, Col } from 'antd'
import './index.less'
// import Util from '../../utils/utils'
// import axios from '../../axios'
import { connect } from 'react-redux'
class Header extends React.Component {
    state={}
    componentWillMount () {
      let info = localStorage.getItem('access_info')
      if (info) {
        this.setState({
          userName: JSON.parse(info).username
        })
      }
    }

    exitfn () {
      localStorage.setItem('access_info', '')
      window.location.href = '/#/login'
    }

    render () {
      const { menuType } = this.props
      return (
        <div className="header">
          <Row className="header-top">
            {
              menuType
                ?<Col span="6" className="logo">
                  <img src="/assets/logo-ant.svg" alt="" />
                  <span>IMooc 通用管理系统</span>
                </Col>:''
            }
            <Col span={menuType?18:24}>
              <span>欢迎，{this.state.userName}</span>
              <span className="exitBtn" onClick={this.exitfn}>退出</span>
            </Col>
          </Row>
        </div>
      )
    }
}
const mapStateToProps = state => {
  return {
    menuName: state.menuName
  }
}
export default connect(mapStateToProps)(Header)